const invoicesSelected = {
  total_size: 0,
  total: '0,00',
  net_total: '0,00',
  invoices: [],
  errors: []
}

export default {
  invoicesTotal: {
    total_size: 0,
    total: '0,00',
    total_liquid: '0,00'
  },
  initialInvoicesSelected: { ...invoicesSelected },
  invoicesSelected: { ...invoicesSelected },
  taxCommission: {
    tax: '0,00',
    commission: '0'
  }
}



// WEBPACK FOOTER //
// ./src/features/invoices/store/state.js